import { getHousingProductSnippetContent } from 'constants/routes';
import { fromFetch } from 'rxjs/fetch';

function getHousingProductSnippetContentRequest$(searchParameters) {
const requestObject = {
        method: 'POST',
        body: JSON.stringify({
          searchCommand: {
            ...searchParameters,
          },
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        selector: (response) => response.json(),
      };
      return fromFetch(getHousingProductSnippetContent, requestObject);
}

export default getHousingProductSnippetContentRequest$;
